import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { AuthService } from '../../auth/auth.service';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { SharedService } from '../../shared/shared.service';
import { AgentService } from '../agent.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
const PASSWORD_REGEX = /((?=.*\d)(?=.*[A-Za-z])(?=.*[0-9]).{6,18})/;

@Component({
    selector: 'app-agent-reset-password',
    templateUrl: './reset-password-component.html',

  })
  
  export class ResetAdminPasswordComponent implements OnInit {
    // public variable define
  public token: string;
  public password: string;
  public confirm_password: string;
  public is_password_valid: boolean;
  public confirm_pass_valid: boolean ;
  public form;

  constructor(private fb: FormBuilder, private activatedRoute: ActivatedRoute,
    private sharedService: SharedService, private authService: AuthService, private router: Router,
    private localStorageService: LocalStorageService, private dialog: MatDialog) {
     this.form = fb.group({
        passwordFormControl: ['', Validators.compose([Validators.required, Validators.pattern(PASSWORD_REGEX)])],
        confirmPasswordFormControl: ['']
        }, {
        validator: PasswordValidation.MatchPassword
        })
    this.sharedService.setHeaderTitle('default_page');
    const that = this.sharedService;
    setTimeout(function(){
      that.setHeaderErrorMessage('create_new_password', false, 'notification error', '');
      that.setHeaderTitle('create_new_password');
    }, 10);
    this.activatedRoute.params.subscribe((params: Params) => {
    this.token = params['token'];
    });
    this.confirm_pass_valid = false ;
   }

  ngOnInit() {
  }

  resetPasswordValidate(event: any) {
   if (this.password !== '' && this.confirm_password !== '' && this.password !== undefined &&
   this.confirm_password !== undefined &&  this.password.length > 5 &&
   this.confirm_password.length > 5 && this.password.match(PASSWORD_REGEX) && (this.password === this.confirm_password)) {
      this.is_password_valid = true;
      if (event.keyCode === 13) {
        document.getElementById('btn-click').click();
      }
    }else {
      this.is_password_valid = false;
    }
  }
  confirmPasswordMatch(event: any) {
  if (this.password !== '' && event.keyCode !== 13) {
    this.confirm_password = '';
  }
}
  // make call reset password
  resetPassword() {
    this.sharedService.setHeaderErrorMessage('create_new_password', false, 'notification error', '');
    this.authService.createNewAdminPassword({'token': this.token, 'password': this.password, 'isReset': true})
      .then(res => {        
            this.dialog.open(ChangePasswordSuccess);          
      }).catch((ex)=>{
        window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('create_new_password', true, 'notification error', "Unable to save password");       
      });
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'change-password-success',
  // tslint:disable-next-line:max-line-length
  template : `<div class="dialog-main"><button mat-icon-button class="dialog-close-btn" [mat-dialog-close]="true"><mat-icon>&#xE5CD;</mat-icon></button><div class="dialog-info"><h3 class="text-center">Success</h3><p>Your password has been successfully reset.</p></div></div><div class="footer"><button mat-button class="double-block-btn" [mat-dialog-close]="true" (click)="successOk()">Ok</button></div>`,
})
// tslint:disable-next-line:component-class-suffix
export class ChangePasswordSuccess {
  // tslint:disable-next-line:max-line-length
  constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService, private authService: AuthService, private router: Router, private localStorageService: LocalStorageService, private dialog: MatDialog) {

  }

  successOk() {
    this.router.navigate(['./internal-user/sign-in']);
  }
}

export class PasswordValidation {
    static MatchPassword(AC: AbstractControl) {
       const password = AC.get('passwordFormControl').value; // to get value in input tag
       const confirmPassword = AC.get('confirmPasswordFormControl').value; // to get value in input tag
        if (password !== confirmPassword) {
            AC.get('confirmPasswordFormControl').setErrors( {MatchPassword: true} )
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/agent/reset-password/reset-password-component.ts